import { PeakType } from '@havenengineering/module-shared-owners-library/dist/enums/peakType';
import styles from './Let2OwnBreakSummary.module.scss';
const MaxBreakList = ({ let2OwnSummary }) => {
    const getMaxBreaksForPeakType = (peakType) => {
        if (!(let2OwnSummary === null || let2OwnSummary === void 0 ? void 0 : let2OwnSummary.summary))
            return 0;
        return (let2OwnSummary.summary[peakType].midweek.max + let2OwnSummary.summary[peakType].weekend.max);
    };
    return (<div className={styles.maxBreakList}>
      <span>Maximum number of breaks:</span>
      {`${getMaxBreaksForPeakType(PeakType.PEAK)} peak, ${getMaxBreaksForPeakType(PeakType.OFF_PEAK)} off-peak, ${getMaxBreaksForPeakType(PeakType.SUPER_PEAK)} super peak`}
    </div>);
};
export default MaxBreakList;
